<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">
    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div #extContainer
           class="inner wrap flex-column">

        <app-search-box #extHeader
                        [keyword]="keyword"
                        [placeholder]="placeholder"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_TOTAL"
                        [top]="scrollTop"
                        (search)="onSearch($event)"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout">

            <div #extBody2
                 class="book-layout-wrap">

              <div class="book-page-list">

                <div #extBody
                     class="book-page-group">

                  <div class="page-box" >
                    <div #container
                         class="page-contents scroll-effect over-y">

                      <article #page
                               class="result-list-layout1" style="padding-bottom: 20px;">
                        <div #innerScroll
                             class="list-wrap">

                          <!-- 단어 목록 -->
                          <ng-container *ngIf="!IsLoading && countWord > 0">
                            <div class="subject-box type-1">
                              <div class="subject-txt">단어 목록</div>
                            </div>

                            <ul>
                              <li *ngFor="let word of listWord; let idx = index">
                                <app-word-list-item [word]="word"
                                                    (viewInit)="onWordViewInit($event)"
                                                    (click)="onSelectWord($event, word)">
                                </app-word-list-item>
                              </li>

                              <li *ngIf="!IsLoading && listWord && countWord > listWord.length">
                                <a class="more-result"
                                   [routerLink]="['/word', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countWord }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>

                          <!-- 지방어 목록 -->
                          <ng-container *ngIf="!IsLoading && countDialect > 0">
                            <div class="subject-box type-2" style="margin-top: 5.0rem">
                              <div class="subject-txt">우리말 목록</div>
                            </div>

                            <ul>
                              <li *ngFor="let dialect of listDialect; let idx = index">
                                <app-dialect-item class="item-box"
                                                  [dialect]="dialect"
                                                  (viewInit)="onDialectViewInit($event)"
                                                  (click)="onSelectDialect($event, dialect)">
                                </app-dialect-item>
                              </li>

                              <li *ngIf="!IsLoading && listDialect && countDialect > listDialect.length">
                                <a class="more-result"
                                   [routerLink]="['/dialect', 'list', LIST_TYPE.SERVER]" [queryParams]="{ keyword: keyword }">{{ countDialect }}개 더 보러 가기</a>
                              </li>
                            </ul>
                          </ng-container>


                          <ul *ngIf="IsLoading">
                            <li class="reload-icon">
                              <img src="assets/img/loading_icon.gif">
                            </li>
                          </ul>


                          <ul *ngIf="!IsLoading && !(loadComplete$ | async)">
                            <li class="no-result" >
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">결과가 없습니다.</div>
                            </li>
                          </ul>

                        </div>
                      </article>

                    </div>

                  </div>
                  <div class="page-box">

                    <!-- 도움말 -->
                    <app-word-help-btn></app-word-help-btn>

                    <app-word-detail #wordDetail
                                     *ngIf="curWord"
                                     [autoPlay]="autoPlay"
                                     [word_id]="curWord.id"></app-word-detail>

                    <app-dialect-detail *ngIf="curDialect"
                                        class="page-contents over-y scroll-effect"
                                        [dialect_id]="curDialect.id"></app-dialect-detail>
                  </div>

                  <div *ngIf="showScrollDown"
                       class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>


  </div>


  <!-- app-footer></app-footer -->

  <app-common-popups></app-common-popups>

</div>
